module.exports = __webpack_public_path__ + "img/marktingAddeb.6a2043c9.svg";